<template>
  <div>
    <header-unauthenticated></header-unauthenticated>
    <div class="container">
      <div class="login login--header-padding">
        <img src="@/assets/superliga/logo-3x.png" alt="" class="login__logo" v-if="$config.MODE == 'SUPERLIGA'">
        <img src="@/assets/logo.svg" alt="" class="login__logo" v-else>
        <div class="form-group">
          <input 
          type="text"
          v-model.trim="$v.userModel.firstName.$model"
          :class="{'has-error': $v.userModel.firstName.$error && $v.userModel.firstName.$invalid, 'with-value': $v.userModel.firstName.$model != ''}"
          :id="$t('register.form.firstName')" class="form-control" required>
          <label class="form-control-placeholder" :for="$t('register.form.firstName')">{{$t('register.form.firstName')}}</label>
        </div>
        <div class="form-group">
          <input 
          type="text"
          v-model.trim="$v.userModel.lastName.$model"
          :class="{'has-error': $v.userModel.lastName.$error && $v.userModel.lastName.$invalid, 'with-value': $v.userModel.lastName.$model != ''}"
          :id="$t('register.form.lastName')" class="form-control" required>
          <label class="form-control-placeholder" :for="$t('register.form.lastName')">{{$t('register.form.lastName')}}</label>
        </div>
        <div class="form-group">
          <input 
          type="email"
          v-model.trim="$v.userModel.email.$model"
          :class="{'has-error': $v.userModel.email.$error && $v.userModel.email.$invalid, 'with-value': $v.userModel.email.$model != ''}"
          :id="$t('register.form.email')" class="form-control" required>
          <label class="form-control-placeholder" :for="$t('register.form.email')">{{$t('register.form.email')}}</label>
        </div>
        <div class="form-group">
          <input 
          type="password"
          v-model.trim="$v.userModel.password.$model"
          :class="{'has-error': $v.userModel.password.$error && $v.userModel.password.$invalid, 'with-value': $v.userModel.password.$model != ''}"
          :id="$t('register.form.password')" class="form-control" required>
          <label class="form-control-placeholder" :for="$t('register.form.password')">{{$t('register.form.password')}}</label>
        </div>
        <div class="form-group">
          <input 
          type="password"
          v-model.trim="$v.userModel.passwordConfirm.$model"
          :class="{'has-error': $v.userModel.passwordConfirm.$error && $v.userModel.passwordConfirm.$invalid, 'with-value': $v.userModel.passwordConfirm.$model != ''}"
          :id="$t('register.form.repeatPassword')" class="form-control" required>
          <label class="form-control-placeholder" :for="$t('register.form.repeatPassword')">{{$t('register.form.repeatPassword')}}</label>
        </div>
        <div class="form-group">
          <label for="terms-and-conds" class="login__terms">
            <input 
              type="checkbox" 
              :name="$t('register.form.termsAndConds')" 
              id="terms-and-conds" 
              v-model.trim="$v.userModel.termsAndCond.$model"
              :class="{'has-error': $v.userModel.termsAndCond.$error && $v.userModel.termsAndCond.$invalid}">
            <a href="javascript:;" @click="gotoTermsAndCond()" >{{$t('register.form.termsAndConds')}}</a>
          </label>
        </div>

        <button class="button button--white" @click.prevent="createUser()" :disabled="$v.userModel.$invalid || submitted">
          <template v-if="!submitted">
            {{$t('register.createAccount')}}
          </template>
          <template v-else>
            {{$t('register.loading')}} <div class="loading-points"><span>.</span><span>.</span><span>.</span></div>
          </template>
        </button>
        <img src="@/assets/logo.svg" alt="" class="login__logo-footer" v-if="$config.MODE == 'SUPERLIGA'">
      </div>
    </div>
  </div>
</template>

<script>
import { required, email, sameAs } from 'vuelidate/lib/validators'
import HeaderUnauthenticated from '@/components/Header/Unauthenticated.vue'

export default {
  components: {
    HeaderUnauthenticated
  },
  data() {
    return {
      userModel: {
        firstName: "",
        lastName: "",
        email: "",
        password: "",
        passwordConfirm: "",
        termsAndCond: false
      },
      submitted: false
    }
  },
  methods: {
    async createUser() {
      this.$v.$touch()
      if (!this.$v.$invalid) {
        this.submitted = true
        const request = await this.$store.dispatch('userCreate', this.userModel)
        if (request && request.status == 200) {
          this.$router.push(`/register/activateUser/${this.userModel.email}`)
          setTimeout(() => {
            this.submitted = false
          }, 1000)
        } else {
          this.submitted = false
        }
      }
    },
    gotoTermsAndCond() {
      if(window["cordova"] != undefined) {
        window.open = window["cordova"].InAppBrowser.open;
      }
      window.open('https://www.fanfestapp.com/privacy.html', '_system');
    },
  },
  validations: {
    userModel: {
      firstName: {
        required
      },
      lastName: {
        required
      },
      email: {
        required,
        email
      },
      password: {
        required
      },
      passwordConfirm: {
        required,
        sameAsPassword: sameAs("password")
      },
      termsAndCond: {
        sameAs: sameAs( () => true )
      }
    }
  }
}
</script>

<style lang="scss">
  @import '@/styles/_variables';
  
  .login {
    &__terms {
      color: $white!important;
      @include font-settings(xmilli, base);
      text-transform: uppercase;
      font-family: $font-barlow;
      font-weight: 600;
      padding-left: $margin-base;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      width: 100%;
      max-width: 300px;
      flex-direction: row;
      padding-top: $margin-milli / 2;
      text-decoration: underline;
    }

    input[type=checkbox] {
      border-radius: 50%;
      -webkit-appearance: none;
      border: 1px solid $white;
      width: $margin-small;
      height: $margin-small;
      margin: 0 $margin-milli 0 0;

      &:checked {
        background: tomato;
      }
    } 
  }
</style>